import {
    GET_DASHBOARD_COUNTS_PENDING,
    GET_DASHBOARD_COUNTS_FULFILLED,
    GET_DASHBOARD_COUNTS_REJECTED,
} from '../../actions/action-constants';

const initialState = {
    loading: true,
    errors: [],
    error: '',

    referrals: -1,
    clients: -1,
    postdischarges: -1,

    postdischarges90d: -1,
    postdischarges180d: -1,
    postdischarges12m: -1,
    postdischarges24m: -1,
    postdischarges36m: -1,

    archivedreferrals: -1,
    archivedclients: -1,
    archivedpostdischarges: -1,
};

const reducerGlobals = (state = initialState, action) => {
  var dataEntry;
  switch (action.type) {
    case GET_DASHBOARD_COUNTS_PENDING:
        state = {
            ...state,
            loading: true
        };
        break;
    case GET_DASHBOARD_COUNTS_FULFILLED:
        var referrals = -1;
        var clients = -1;
        var postdischarges = -1;
        
        var postdischarges90d = -1;
        var postdischarges180d = -1;
        var postdischarges12m = -1;
        var postdischarges24m = -1;
        var postdischarges36m = -1;
    
        var archivedreferrals = -1;
        var archivedclients = -1;
        var archivedpostdischarges = -1;

        dataEntry = (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) ? action.payload.data.counts[0] : [] ;
        if (typeof(action.payload.data) !== "undefined" && action.payload.data !== null ) {                        
            referrals = dataEntry.referrals;
            clients = dataEntry.clients;
            postdischarges = dataEntry.postdischarges;
            
            postdischarges = dataEntry.postdischarges;
            postdischarges90d = dataEntry.postdischarges90d;
            postdischarges180d = dataEntry.postdischarges180d;
            postdischarges12m = dataEntry.postdischarges12m;
            postdischarges24m = dataEntry.postdischarges24m;
            postdischarges36m = dataEntry.postdischarges36m;
    
            archivedreferrals = dataEntry.archivedreferrals;
            archivedclients = dataEntry.archivedclients;
            archivedpostdischarges = dataEntry.archivedpostdischarges;
        }
        state = {
            ...state,
            loading: false,

            referrals: referrals,
            clients: clients,
            postdischarges: postdischarges,
            
            postdischarges90d: postdischarges90d,
            postdischarges180d: postdischarges180d,
            postdischarges12m: postdischarges12m,
            postdischarges24m: postdischarges24m,
            postdischarges36m: postdischarges36m,
    
            archivedreferrals: archivedreferrals,
            archivedclients: archivedclients,
            archivedpostdischarges: archivedpostdischarges,
        };
        break;
    case GET_DASHBOARD_COUNTS_REJECTED:
        state = {
            ...state,
            loading: false,
            errors: [action.payload.response],
        };
        break;

    default:
        return state;
  }

  return state;
};
export default reducerGlobals;
